
export default function Loading() {

  const style = {
    textAlign: 'center',
    fontSize: '1.5rem'
  }

  return (
    <div style={style}>
      🌀 Loading...
    </div>
  );
}
